module.exports = __webpack_public_path__ + "genomed_sa_01.jpg?ae2dffa1412c59c00ac4bc632f5fdcc4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/genomed_sa_01.jpg
// module id = 141
// module chunks = 0